import type { IStationsLineRef } from '../../../api/types';
import { StatusBanner } from '../../StatusBanner';

/**
 * 「接続線の発車見込み案内」(`departure_forecast`) で、運行情報の参照元
 * (アイステイションズ路線 / `istations_lines`) が **未設定のとき** に出す警告 (SBI-5)。
 *
 * ## なぜ警告するか
 *
 * 運転見合わせの抑止は `istations_lines` を手がかりに行われる。未設定のコンテンツでは
 * 抑止が効かず、運転見合わせ中でも「発車の見込みです」と案内してしまうおそれがある。
 * 設定漏れに気づけるよう、モード選択中だけ警告を出す。
 *
 * ## 入力は必須にしない
 *
 * 警告のみで、保存はブロックしない (PO 回答 7)。バリデーションにも加えない。
 * 表示条件は「発車見込みモード」かつ「`istations_lines` が 0 件 / 未設定」。
 * 1 件以上設定済みなら何も描画しない。
 *
 * part1 (`ConnectingLineDelayFields`) と part2 (`ConnectingLineBlock`) の両方から使う。
 */
export function DepartureForecastIStationsWarning({
  istationsLines,
  testId,
}: {
  /** 現在の `istations_lines` (part1: properties 直下 / part2: lines[i])。 */
  istationsLines: readonly IStationsLineRef[] | undefined;
  /** 呼び出し元ごとに一意な data-testid (part2 は接続線 index 入り)。 */
  testId: string;
}): React.JSX.Element | null {
  if (Array.isArray(istationsLines) && istationsLines.length > 0) return null;
  return (
    <StatusBanner variant="warning" data-testid={testId}>
      <strong>「運行情報と連携」の路線が未設定です。</strong>
      運転見合わせの抑止は「運行情報と連携」で選んだ路線を手がかりに行うため、
      未設定のままだと運転見合わせ中でも発車見込みを案内するおそれがあります。
      上の「運行情報と連携」を設定してください（未設定でも保存はできます）。
    </StatusBanner>
  );
}
